import { Component, Input, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { TimeSetupService } from "../shared/data.service";
import * as moment from "moment";

@Component({
	selector: "caass-grade-grid",
	templateUrl: "./grade-grid.component.html",
	styleUrls: ["./grade-grid.component.css"],
})
export class GradeGridComponent implements OnInit {
	constructor(private timeSetupService: TimeSetupService, private confirmationService: ConfirmationService) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		if (this.SchoolID != undefined) {
			this.loadGradeList();
		}
	}

	ngOnChanges() {
		if (this.SchoolID != undefined) {
			this.loadGradeList();
		}
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() SchoolID: any;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedGrade: any;
	lstGrade: any = [];

	//Filter lists

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "GradeLevelDesc", header: "Grade" },
		// { field: 'TardyTime', header: 'Tardy Time' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadGradeList() {
		this.loading = true;

		var result = this.timeSetupService.TimeSettingsGradeSelectList(this.SchoolID);
		result.subscribe(
			(response) => {
				this.lstGrade = response;

				var TodayStr: String = moment(new Date()).format("MM/DD/YYYY");

				for (var i = 0; i < this.lstGrade.length; i++) {
					var next = this.lstGrade[i];

					//Create Date from Tardy Time string
					if (next.TardyTime != "") {
						next.TardyTimeDate = new Date(TodayStr + " " + String(next.TardyTime));
					} else {
						var Today = new Date();
						Today.setHours(0, 0, 0, 0);
						next.TardyTimeDate = Today;
					}
				}
				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////
	onUpdate(val) {
		var fTime = moment(new Date(val.TardyTimeDate)).format("HH:mm:00");

		var result = this.timeSetupService.TimeSettingsUpdateGradeTardyTime(val.GradeLevelID, this.SchoolID, fTime);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "timegrade",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Grade Level Tardy Time was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadGradeList();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "timegrade",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the Grade Level's Tardy Time",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onReset(val) {
		//There should only be 1 school for a given school ID
		var next = val;

		var TodayStr: String = moment(new Date()).format("MM/DD/YYYY");

		if (next.TardyTime != "") {
			next.TardyTimeDate = new Date(TodayStr + " " + String(next.TardyTime));
		} else {
			var Today = new Date();
			Today.setHours(0, 0, 0, 0);
			next.TardyTimeDate = Today;
		}
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedGrade = val.data;
	}
	onRowUnselect(val) {
		this.SelectedGrade = null;
	}

	////////////////////////////////////////////
}
